import * as TK from 'components/PDP/Details/components/PasControl/components/DateSelection/components/NotAvailableAlert/translations/constants';

export const notAvailableAlertCommonLocale = {
  [TK.TITLE]:
    "We're sorry, but this product is not available for the zip code you selected.",
  [TK.BODY]:
    'Please select another zip code or click below to see other products available for your selected zip code.',
  [TK.BUTTON]: 'See Available Products',
};
